import * as React from 'react';
const classNames = require('classnames');

import Label from './Label';

interface Props {
	title?: {};
	name: string;
	radioOptions: Array<RadioInput>;
	onBlur?: (value: {}) => void;
	onChange?: (value: {}) => void;
	className?: string;
	children?: {};
	required?: boolean;
}

interface RadioInput {
	id: string;
	label: {};
	value: string;
	checked?: boolean;
	onBlur?: (value: {}) => void;
	onChange?: (value: {}) => void;
	className?: string;
	disabled?: boolean;
	conditionalChildren?: {};
}

const RadioGroup: React.StatelessComponent<Props> = props => {
	return (
		<div
			className={classNames('form-group', props.className, {
				'form-group-required': props.required
			})}
			onBlur={props.onBlur}
			onChange={props.onChange}
		>
			{props.title && <Label required={props.required}>{props.title}</Label>}
			{props.radioOptions.map(radio => (
				// TODO: Only include wrapper div if conditionalChildren exists
				<div className={classNames('form-check-wrapper', radio.className)} key={radio.value}>
					<div
						className={classNames('form-check custom-control custom-radio', {
							disabled: radio.disabled
						})}
					>
						<input
							type="radio"
							name={props.name}
							value={radio.value}
							id={radio.id}
							checked={radio.checked}
							onBlur={radio.onBlur}
							onChange={radio.onChange}
							disabled={radio.disabled}
							className="form-check-input custom-control-input"
						/>
						<label className="form-check-label custom-control-label" htmlFor={radio.id}>
							{radio.label}
						</label>
					</div>
					{radio.conditionalChildren}
				</div>
			))}
			{props.children}
		</div>
	);
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/RadioGroup.tsx